<template>
    <div class="main">
        <div class="query-item">
            <div>
                申请主体
                <a-input class="inp ml24" placeholder="请输入" v-model:value="query.deptName"></a-input>
            </div>
            <div class="ml30">
                测试牌照
                <a-input class="inp ml24" placeholder="请输入" v-model:value="query.carTestNum"></a-input>
            </div>
            <div class="ml24">
                状态
                <a-select v-model:value="query.checkStatus" class="inp ml24" placeholder="请输入">
                    <a-select-option value="">全部</a-select-option>
                    <a-select-option :value="0">等待审核</a-select-option>
                    <a-select-option :value="1">审核通过</a-select-option>
                    <a-select-option :value="2">审核不通过</a-select-option>
                </a-select>
            </div>
            <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
            <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
            <div></div>
        </div>
        <a-table :columns="columns" :row-key="(record) => record.id" :data-source="dataSource" size="middle"
            class="mt23" :pagination="pagination" :scroll="{ y: 'auto', }"
            v-autoHeight="{ extraHeight: 88, trHeight: 47 }">
            <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'status'">
                    <span v-if="record.checkStatus == 0">待审核</span>
                    <span v-if="record.checkStatus == 1">审核通过</span>
                    <span v-if="record.checkStatus == 2">审核不通过</span>
                </template>
                <template v-if="column.key === 'category'">

                    {{ getSingleTypeValue(appStore.SysDictVOList,
                    'testType' + 'category' + record.testType) }}
                </template>
                <template v-else-if="column.key === 'action'">
                    <span v-if="record.checkStatus === 0 && store.hasPermi('qualification:delayed:review')">
                        <a @click="audit(record)">延期审核 </a>
                    </span>
                    <span v-else>
                        <a @click="detail(record)">查看详情</a>
                    </span>
                </template>
            </template>
        </a-table>

        <auditModal :modalTitle="'延期审核'" :isDetailStatus="true" ref="modalRef" @saveEvent=saveEvent>
            <div class="mt20 mb75">
                <div class="modal_content">
                    <div class="file_text">
                        <FileTextOutlined class="file_icon mr5" />道路延期申请表.pdf
                    </div>
                    <div class="update_btn">
                        <div><i class="iconfont icon-dianjixiazaiicon update_icon mr5"></i>
                            <a :href="details.uploadFile" target="_blank">点击下载</a>

                        </div>
                    </div>
                </div>
                <div class="radio_class mt24">
                    <span style="padding-left: 14px;">审核意见</span>
                    <a-radio-group class="ml26" v-model:value="checkStatus">
                        <a-radio :value="1">通过</a-radio>
                        <a-radio :value="2">不通过</a-radio>
                    </a-radio-group>
                </div>
                <div class="radio_class mt24 area_class">
                    专家组意见
                    <a-textarea class="area_width" v-model:value="checkMsg" placeholder="审核不通过时为必填" :rows="4" />
                </div>
            </div>
        </auditModal>

        <auditModal :modalTitle="'详情'" :isDetailStatus="false" ref="modalDetailRef">
            <div class="mt20 mb62" v-if="details">
                <div class="mt16">
                    <div class="modal_item">
                        <span class="modal_item_text1">测试主体：</span>
                        <span class="modal_item_text2">{{ details.deptName }}</span>
                    </div>
                    <div class="modal_item" style="border-top: none;">
                        <span class="modal_item_text1">测试牌照：</span>
                        <span class="modal_item_text2">{{ details.carTestNum }}</span>
                    </div>
                </div>
                <div class="modal_content mt16">
                    <div class="file_text">
                        <FileTextOutlined class="file_icon mr5" />智能网联汽车示范应用延期申请表.pdf
                    </div>
                    <div class="update_btn">
                        <div><i class="iconfont icon-dianjixiazaiicon update_icon mr5"></i>
                            <a :href="details.uploadFile" target="_blank">点击下载</a>
                        </div>
                    </div>
                </div>
                <div class="mt16">
                    <div class="modal_item">
                        <span class="modal_item_text1">审批时间：</span>
                        <span class="modal_item_text2">{{ details.checkTime }}</span>
                    </div>
                    <div class="modal_item" style="border-top: none;">
                        <span class="modal_item_text1">审批人：</span>
                        <span class="modal_item_text2">{{ details.checkUserName }}</span>
                    </div>
                    <div class="modal_item" style="border-top: none;">
                        <span class="modal_item_text1">审批结果：</span>
                        <span class="modal_item_text2">{{ details.checkStatus == 1 ? '通过' : '不通过' }}</span>
                    </div>
                    <div class="modal_item" style="border-top: none;">
                        <span class="modal_item_text1">审核意见：</span>
                        <span class="modal_item_text2">{{ details.checkMsg }}</span>
                    </div>
                    <div class="modal_item" style="border-top: none;">
                        <span class="modal_item_text1">专家组意见：</span>
                        <span class="modal_item_text2">{{ details.carTestNum }}</span>
                    </div>
                </div>
            </div>
        </auditModal>

    </div>
</template>
<script setup>
import { ref, onMounted, reactive, watch, nextTick } from "vue";
import { useRouter } from "vue-router";
import { message } from 'ant-design-vue'
import auditModal from '../../components/modal/index.vue'
import { qualificationDelayList, qualificationDelayDetail, qualificationDelayAuditing } from "@/api/qualification/index"
import { getSingleTypeValue } from "@/utils/matchDic.js";
import useAppStore from "@/store/modules/app";
import Cookies from "js-cookie";
import useUserStore from "@/store/modules/user";

const appStore = useAppStore();
const store = useUserStore();
const router = useRouter();

const columns = [
    {
        title: "编号",
        dataIndex: "id",
        key: "id",
    },
    {
        title: "申请主体",
        dataIndex: "deptName",
        key: "deptName",
    },
    {
        title: "测试类型",
        dataIndex: "category",
        key: "category",
        // width: 100,
    },
    {
        title: "测试牌照",
        key: "carTestNum",
        dataIndex: "carTestNum",
        // width: 80,
    },
    {
        title: "车架号",
        key: "carFrameNum",
        dataIndex: "carFrameNum",
    },
    {
        title: "延期日期",
        key: "delayTime",
        dataIndex: "delayTime",
        // width: 240,
    },
    {
        title: "更新时间",
        key: "updateTime",
        dataIndex: "updateTime",
    },
    {
        title: "状态",
        key: "status",
        dataIndex: "status",
    },
    {
        title: "操作",
        key: "action",
    },
];


let dataSource = ref([]);
let query = reactive({
    deptName: '',
    carTestNum: "",
    checkStatus: ''
});


const pagination = reactive({
    total: 0,
    size: "middle",
    defaultPageSize: 10,
    current: 1,
    pageSize: 20, //每页中显示10条数据
    showSizeChanger: true,
    showQuickJumper: false,
    pageSizeOptions: ["10", "20", "30"], //每页中显示的数据
    showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
    onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
    onChange: pageChange, //点击页码事件
    showSizeChange: pageSizeChange,
});

function pageChange(page, pageSize) {
    pagination.current = page;

    // 获取表格数据
    getData();
}

function pageSizeChange(current, size) {
    console.log(size);
    pagination.pageSize = size;

    // 获取表格数据
    getData();
}

const search = () => {
    pagination.current = 1
    getData();
};

const reset = () => {
    query.deptName = "";
    query.carTestNum = "";
    query.checkStatus = ''
    pagination.current = 1
    getData()
};







const getData = () => {
    const data = {
        pageIndex: pagination.current,
        pageSize: pagination.pageSize,
        conditionMap: { ...query },
    };
    qualificationDelayList(data).then((res) => {
        res.data.records.map((item, index) => {
            item.ranking = index + 1;
        });
        dataSource.value = res.data.records || [];
        pagination.total = res.data.total;
    });
};


const modalRef = ref()
const audit = (record) => {
    nextTick(() => {
        getDetail(record)
        setTimeout(() => {
            modalRef.value.showModal();
        }, 200);
    })
};

let details = ref({})
function getDetail(row) {
    let obj = {
        qualificationId: row.qualificationId,
        id: row.id
    }
    qualificationDelayDetail(obj).then(res => {
        if (res.code == 200) {
            console.log(details.value);
            details.value = res.data;
            console.log(details.value);

        }
    })
}

//审核
let checkMsg = ref('');
let checkStatus = ref(1);
const saveEvent = () => {
    console.log('123')
    let ry = JSON.parse(Cookies.get('ruoyiIds'));
    console.log(ry)
    let obj = {
        checkMsg: checkMsg.value,
        "checkStatus": checkStatus.value,
        "check_ry_user_id": ry.userId,
        "id": details.value.id
    }

    if (checkStatus.value === 2 && checkMsg.value == '') {
        modalRef.value.open=true
        message.error('审核不通过时,专家组意见必填')
    } else {
        qualificationDelayAuditing(obj).then(res => {
            console.log(res);
            if (res.code === 200) {
                message.success('成功')
                checkMsg.value = '';
                // 获取表格数据
                getData();
                modalRef.value.open=false
            }
        })
    }


}

const modalDetailRef = ref()
const detail = (record) => {
    nextTick(() => {
        getDetail(record)
        setTimeout(() => {
            modalDetailRef.value.showModal()
        }, 500);
    })
}

onMounted(async () => {
    getData();
});


</script>

<style lang="less" scoped>
.inp {
    width: 13.5vw;
}

.query-item {
    display: flex;
    // justify-content: space-between;
}


.modal_content {
    // width: 516px;
    height: 154px;
    background: rgba(246, 248, 250, 1);
    display: flex;
    flex-direction: column;
    align-items: center;

    .file_text {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #1D2129;
        padding-top: 24px;

        .file_icon {
            color: rgba(24, 111, 242, 1);
        }

    }

    .update_btn {
        cursor: pointer;
        padding: 3px 0;
        width: 100px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #636D7B;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        color: #636D7B;
        margin-top: 34px;
        text-align: center;

        a {
            color: #636D7B;
        }
    }
}

.radio_class {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: rgba(29, 33, 41, 1);
}

.area_class {
    display: flex;
    margin-bottom: 63px;
}

.area_width {
    width: 420px;
    margin-left: 26px;
}

.modal_item {
    // height: 48px;
    border: 1px solid #E1E7EF;
    padding: 17px 0 11px 28px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
}

.modal_item_text1 {
    color: rgba(99, 109, 123, 1);
    display: inline-block;
    width: 90px;
    text-align: right;
}

.modal_item_text2 {
    color: rgba(29, 33, 41, 1);
}

/deep/.ant-input::placeholder {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #68767E;
}

/deep/.ant-select-selector {
    background-color: #F2F4F7 !important;
    color: #68767E !important;
}

.main {
    padding: 20px;
    height: calc(100vh - 70px - 57px);
    background-color: #ffffff;
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(10, 33, 46, 1);
    background-color: rgba(239, 240, 245, 1);
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
    color: rgba(104, 118, 126, 1);
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead>tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
    width: 0px;
}

a {
    color: #1E8EF2;
}

.ml26 {
    margin-left: 26px;
}
</style>
